import React from "react";
import styled, {injectGlobal} from "styled-components";

const LightWindowWrapper = styled.article`
  background: rgba(0,0,0,.4);
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  cursor: initial;
`;

export default LightWindowWrapper;



// WEBPACK FOOTER //
// ./src/styled-components/LightWindowWrapper.js